import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-cardIssueApply`;

const list = (merchantId, filter, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/cardIssueApplys/page`, {
		...filter,
		page,
		pageSize,
	});
};

const listV2 = (merchantId, filter, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/giftCardIssueApplys/page`, {
		...filter,
		page,
		pageSize,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/cardIssueApplys/${id}`);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/cardIssueApplys`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/cardIssueApplys/${id}`, payload);
};

const createECard = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/addEGiftCardIssueApply`,
		payload
	);
};

const updateECard = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/changeEGiftCardIssueApply/${id}`,
		payload
	);
};

const remove = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/cardIssueApplys/${id}`);
};

const sort = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/sort/eGiftCardIssueApplies`,
		payload
	);
};

export default {
	list,
	listV2,
	find,
	create,
	update,
	createECard,
	updateECard,
	sort,
	remove,
};
